import type { ICancellationToken } from '@cian/http-api';

import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IGetBannerEnrichmentsResponse200,
  type IGetBannerEnrichmentsResponse400,
  type TGetBannerEnrichmentsRequest,
  type TGetBannerEnrichmentsResponse_1,
  createGetBannerEnrichmentsModel,
  fetchGetBannerEnrichments,
} from '@/repositories/generated/shared/ad-banner/v1/get-banner-enrichments';

type FetchServiceParams = {
  applicationContext: IQueryStateAppContext;
  cancellationToken: ICancellationToken;
  parameters: TGetBannerEnrichmentsRequest;
};

export function fetchGetBannerEnrichmentsService(params: FetchServiceParams): Promise<TGetBannerEnrichmentsResponse_1> {
  const {
    applicationContext: { httpApi, logger },
    parameters,
    cancellationToken,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createGetBannerEnrichmentsModel(parameters),
    '@/shared/store/ad-banner/v1/get-banner-enrichments/internal/fetchService.ts',
    logger,
  );

  return fetchGetBannerEnrichments<IGetBannerEnrichmentsResponse200, IGetBannerEnrichmentsResponse400>({
    config: { cancellationToken },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
